import Vue from 'vue'
import VScrollLock from 'v-scroll-lock'
import VueMeta from 'vue-meta'

import App from './App'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './filters'

Vue.config.productionTip = false

Vue.use(VScrollLock)
Vue.use(VueMeta)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
